export interface DayData {
  date: Date;
  color: string;
  type: string;
}

export interface MonthData {
  month: number;
  year: number;
  days: DayData[];
}

export type CalendarData = Record<string, DayData>; // Key: YYYY-MM-DD

export const DayColors: Record<string, { background: string; text: string; meaning: string; hours: number }> = {
  PRETO: { background: "bg-black", text: "text-white", meaning: "Dia Normal", hours: 16 },
  CINZA: { background: "bg-gray-400", text: "text-black", meaning: "Sábado e Domingo", hours: 0 },
  AZUL_ESCURO: { background: "bg-blue-800", text: "text-white", meaning: "Hora Extra em Dia Normal", hours: 16.75 },
  AZUL_CLARO: { background: "bg-blue-300", text: "text-black", meaning: "Hora Extra no Sábado", hours: 14.67 }, // Corrigido para 14.67 horas
  VERMELHO: { background: "bg-red-500", text: "text-white", meaning: "Feriado", hours: 0 },
  MARROM: { background: "bg-yellow-700", text: "text-white", meaning: "Recuperação de Perdas Produtivas", hours: 0 },
  ROSA: { background: "bg-pink-500", text: "text-white", meaning: "Férias", hours: 0 },
};

export type ColorOption = keyof typeof DayColors;

// DayCapacities será calculado dinamicamente: Horas do Dia * Unidades por Hora (a ser implementado)
// Os valores abaixo são apenas placeholders ou exemplos iniciais antes da implementação do parâmetro "Unidades por Hora".
export const DayCapacities: Record<ColorOption, number> = {
  PRETO: 2560, // Exemplo: 16 * 160
  CINZA: 0,
  AZUL_ESCURO: 2680, // Exemplo: 16.75 * 160
  AZUL_CLARO: 0, // Será: 14.67 * UnidadesPorHora. Placeholder até a implementação do parâmetro.
  VERMELHO: 0,
  MARROM: 0,
  ROSA: 0,
};

export interface MonthlyStats {
  demand: number;
  capacity: number;
  occupation: number; // Em porcentagem
}

export interface AppParameters {
  dayHours: Record<ColorOption, number>; // Horas configuradas para cada tipo de dia
  dayCapacities: Record<ColorOption, number>; // Calculado: dayHours[type] * unidadesPorHora
  aiPrompt: string;
  unidadesPorHora: number; 
  selectedOpenAIModel: string;
}

